<template>
  <div class="panel">
    <div>
      <el-row>
        <h1 class="info-title">方便简洁功能强大的API</h1>
        <div class="info-content">
          <div>开发者可以在Tigo框架中增加自定义的中间件，同时Tigo框架也为开发者提供了大量的简洁的API，开发者可以使用这些API快速搭建web</div>
          <div>服务。当然，Tigo框架还为开发者提供了binding、logger和request三个工具包，开发者分别可以用来进行结构体实例校验、日志记录以及</div>
          <div>http访问请求。</div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="info-content doc-demo">
            <h3 class="doc-title">文档及示例</h3>
            <div>如果您之前使用过Tornado，那么Tigo对您来说非常容易上手。</div>
            <div>Tigo提供了两种路由方式，开发者可以通过右侧示例进行学习。</div>
            <br/>
            <h3 class="doc-title">相关下载</h3>
            <div>首先，这里提供了离线文档，开发者可<a href="https://karldoenitz.github.io/TigoOld/statics/documentation.pdf" class="link" target="_blank">点击次此</a>处下载文档。</div>
            <div>当然，我们也为开发者提供了几个应用实例，<a href="https://karldoenitz.github.io/TigoOld/source/Demos.zip" class="link" target="_blank">点击此处</a>下载。</div>
            <br/>
            <h3 class="doc-title">框架工具</h3>
            <div>脚手架工具 tiger 是专门为Tigo开发的框架工具，可以用来进行</div>
            <div>新建项目或是更新框架等操作，详情请<a href="https://github.com/karldoenitz/tiger" class="link" target="_blank">点击此处</a>进入项目地址。</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="demo">
            <el-carousel :autoplay=false height="520px">
              <el-carousel-item >
                <img src="../../assets/demo.png" class="demo-pic"/>
              </el-carousel-item>
              <el-carousel-item >
                <img src="../../assets/demo1.png" class="demo-pic"/>
              </el-carousel-item>
              <el-carousel-item >
                <img src="../../assets/demo2.png" class="demo-pic"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DocumentationDemo",
  }
</script>

<style scoped>
  .panel {
    padding-top: 20px;
    height: 800px;
    width: 100%;
    background-color: #f2f2f3;
    font-family: "Avenir", serif;
  }

  .info-title {
    margin-top: 20px;
    font-family: "Avenir", serif;
  }

  .doc-title {
    margin-right: 100px;
  }

  .info-content {
    color: #797e8e;
    font-family: "Avenir", serif;
  }

  .doc-demo {
    margin: 50px 50px 10px 25%;
    overflow: hidden;
    width: 450px;
    height: auto;
    float: right;
  }

  .link {
    text-decoration: none;
  }

  .demo {
    margin: 50px 25% 10px 50px;
    overflow: hidden;
    width: 399px;
    float: left;
  }

  .demo-pic {
    width: 399px;
    height: 520px;
  }

  .el-carousel {
    height: 520px;
  }

  @media screen and (max-width: 913px) {
    .demo {
      display: none;
    }
    .doc-demo {
      display: none;
    }
    .panel {
      padding-top: 20px;
      width: 100%;
      height: auto;
      background-color: #f2f2f3;
      font-family: "Avenir", serif;
      padding-bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ch/DocumentationDemo.vue